import { Color } from '@mui/material';
import { CommonColors, createTheme, ThemeOptions } from '@mui/material/styles';

declare module '@mui/material/styles' {
	interface ThemeOptions {
		status?: PaletteAugmentColorOptions; // @deprecated
		progress?: PaletteAugmentColorOptions; // @deprecated
	}

	interface PaletteAugmentColorOptions {
		red?: string;
		green?: string;
		blue?: string;
		darkBlue?: string;
		orange?: string;
		grey?: string;
		gray?: string;
		light?: string;
	}

	interface Palette {
		primary: PaletteColor;
		status: PaletteColor;
		orange: Palette['primary'];
	}

	interface PaletteOptions {
		light?: PaletteOptions['primary']; // @deprecated
		orange?: PaletteOptions['primary']; // @deprecated
		blue?: PaletteOptions['primary']; // @deprecated
	}

	interface PaletteColor {
		grey?: string;
		grey2?: string;
		darkBlue?: string;
		darkBlueLight?: string;
		orange?: string;
	}

	interface SimplePaletteColorOptions {
		grey?: string;
		grey2?: string;
		darkBlue?: string;
		darkBlueLight?: string;
		orange?: string;
	}

	interface Partial {
		grey?: string;
	}
}

export const backYouTheme = createTheme({
	palette: {
		primary: {
			main: '#004753',
			light: '#f0f0f0',
			grey: '#dee2e6',
			grey2: '#aaaaaa',
			darkBlue: '#004753',
			darkBlueLight: '#004753BD',
			orange: '#F0672F'
		},
		secondary: {
			main: '#D8DFE0'
		},
		light: {
			main: '#f0f0f0'
		},
		orange: {
			main: '#F0672F'
		},
		blue: {
			50: '#F3F6F9',
			100: '#daecff',
			200: '#b6daff',
			300: '#66b2ff',
			400: '#3399ff',
			500: '#007fff',
			600: '#0072e5',
			700: '#0059B2',
			800: '#004c99',
			900: '#004c99',
		},
		grey: {
			50: '#F3F6F9',
			100: '#E5EAF2',
			200: '#DAE2ED',
			300: '#C7D0DD',
			400: '#B0B8C4',
			500: '#9DA8B7',
			600: '#6B7A90',
			700: '#434D5B',
			800: '#303740',
			900: '#1C2025',
		}
	},
	typography: {
		fontFamily: 'Lato, Roboto, sans-serif',
		fontWeightLight: 300,
		fontWeightRegular: 400,
		fontWeightMedium: 500
	},
	status: {
		red: '#DA1923',
		green: '#2ca000',
		blue: '#4589ff',
		darkBlue: '#004753',
		orange: '#F0672F',
		grey: '#aaaaaa'
	},
	progress: {
		green: '#2CA000',
		red: '#9E0007',
		gray: '#668C93',
		light: '#D8DFE0'
	},
	components: {
		MuiInputBase: {
			styleOverrides: {
				root: {
					width: '100%',
					fontSize: 15,
					//height: '42px',
					borderRadius: '0.38rem',
					overflow: 'hidden!important',
					'&:hover, &:focus, &.Mui-focused, &:active': {
						borderWidth: '1px',
					},
				},
			},
		},
		MuiOutlinedInput: {
			styleOverrides: {
				root: {
					//height: '42px',
					borderRadius: '0.38rem',
				},
			},
		},
		MuiSelect: {
			styleOverrides: {
				root: {
					//height: '42px',
					borderRadius: '0.38rem'
				},
			},
		},
		MuiAutocomplete: {
			styleOverrides: {
				root: {
					//height: '42px',
					borderRadius: '0.38rem'
				},
			},
		},
		MuiFormControl: {
			styleOverrides: {
				root: {
					//height: '42px',
					borderRadius: '0.38rem',
					border: 'none'
				},
			},
		},
		MuiFormControlLabel: {
			styleOverrides: {
				root: {
					fontSize: '.9rem',
					marginLeft: 0,
					marginRight: 0,
					marginBottom: 0,
				},
				label: {
					fontSize: '.9rem',
					marginLeft: 0,
					marginRight: 0,
					marginBottom: 0,
				},
			},
		},
		MuiTooltip: {
			styleOverrides: {
				tooltip: {
					backgroundColor: '#004753',
				},
				arrow: {
					color: '#004753',
				}
			}
		},
		MuiAccordion: {
			styleOverrides: {
				root: {
					margin: '0'
				},
			},
		},
		MuiPaper: {
			styleOverrides: {
				root: {
					margin: '0!important'
				},
				elevation: {
					margin: '0!important'
				},
			},
		},
	}
});
